const RNFS = {
  RNFSFileTypeRegular: 'file',
  RNFSFileTypeDirectory: 'directory',
  DocumentDirectoryPath: '/tmp',
  ExternalDirectoryPath: '/tmp',
  TemporaryDirectoryPath: '/tmp',
  exists: async () => false,
  mkdir: async () => true,
  unlink: async () => true,
  readDir: async () => [],
  readFile: async () => '',
  writeFile: async () => true,
  copyFile: async () => true,
  moveFile: async () => true,
  stat: async () => ({ isFile: () => false, isDirectory: () => false }),
  downloadFile: () => ({ promise: Promise.resolve({ statusCode: 200 }) }),
  uploadFiles: () => ({ promise: Promise.resolve({ statusCode: 200, body: '{}' }) })
};

export default RNFS;
